export enum EBillingHealthStatus {
  SuccessfullyBilled,
  Failed,
  Overdue,
  DueLater,
  Excluded,
}
